/* eslint-disable no-use-before-define */
import 'regenerator-runtime/runtime';

import { showAlertModal } from '../global/modal';
import ShippingEstimator from '../cart/shipping-estimator';
import wdSlideout from './ob-slideout';
import {
    getCartContent,
    removeCartItem,
    updateCartItem,
    getCart,
    applyCoupon,
    removeCoupon,
    applyGiftCertificate,
    removeGiftCertificate,
} from './ob-cart-utils';
import StencilUtils from '@bigcommerce/stencil-utils';

function bindCartAccordions($slideout) {
    $slideout.find('.ob-cartTotal-accordion .ob-cartTotal-accordionButton').on('click', (e) => {
        const $button = $(e.currentTarget);
        const $parent = $button.closest('.ob-cartTotal-accordion');

        $parent.toggleClass('ob-cartTotal-accordion--open');
        $button.siblings('.ob-cartTotal-accordionContent').toggle();
    });
}

function getSuccessHandler($slideout, slideoutController) {
    return async () => {
        const cartContent = await getCartContent({ template: 'ob-custom/cart/ob-cart-content' });

        if (slideoutController) {
            slideoutController.setSlideoutContent(cartContent);
            bindEvents($slideout, slideoutController);
            slideoutController.hideLoadingOverlay();
        }
    };
}

function getErrorHandler(slideoutController) {
    return (error) => {
        const errorMessage = error?.data?.errors?.join('\n');

        showAlertModal(errorMessage || 'An error occurred. Please try again.');

        if (slideoutController) {
            slideoutController.hideLoadingOverlay();
        }
    };
}

/**
 * Bind events for the cart items
 * @param {jQuery} $slideout
 * @param {wdSlideout} slideoutController
 */
function bindCartItemActions($slideout, slideoutController) {
    const onError = getErrorHandler(slideoutController);
    const onSuccess = getSuccessHandler($slideout, slideoutController);

    /**
     * Handle the click event for the remove button
     */
    $slideout.find('.ob-cartItem-removeButton').on('click', async (e) => {
        const $button = $(e.currentTarget);
        const $parent = $button.closest('.ob-cartItem');

        const itemId = $parent.data('item-id');

        try {
            slideoutController.showLoadingOverlay();
            await removeCartItem(itemId);
            $('body').trigger('cart-quantity-update');
            await onSuccess();
        } catch (error) {
            onError(error);
        }
    });

    /**
     * Handle the quantity change event
     */
    $slideout.find('.ob-cartItem-quantityInput').on('change', async (e) => {
        const $input = $(e.currentTarget);
        const $parent = $input.closest('.ob-cartItem');

        const itemId = $parent.data('item-id');
        const quantity = $input.val();

        try {
            slideoutController.showLoadingOverlay();
            await updateCartItem(itemId, quantity);
            $('body').trigger('cart-quantity-update');
            await onSuccess();
        } catch (error) {
            getErrorHandler(error, slideoutController);
        }
    });

    /**
     * Handle the quantity increment/decrement event
     */
    $slideout.find('.ob-cartItem-quantityButton').on('click', async (e) => {
        const $button = $(e.currentTarget);
        const $parent = $button.closest('.ob-cartItem');

        const $input = $parent.find('.ob-cartItem-quantityInput');
        const quantity = $input.val();

        if ($button.hasClass('ob-cartItem-quantityButton--increment')) {
            $input.val(Number(quantity) + 1);
            $input.trigger('change');
        } else {
            $input.val(Number(quantity) - 1);
            $input.trigger('change');
        }
    });
}

/**
 * Bind form events in the cart total section
 * @param {jQuery} $slideout
 * @param {wdSlideout} slideoutController
 */
function bindForms($slideout, slideoutController) {
    const onSuccess = getSuccessHandler($slideout, slideoutController);
    const onError = getErrorHandler(slideoutController);

    /**
     * Handle the coupon form submission
     */
    $slideout.find('.ob-coupon-form').on('submit', async (e) => {
        e.preventDefault();

        const $form = $(e.currentTarget);
        const $input = $form.find('#couponcode');
        const couponCode = $input.val();

        try {
            slideoutController.showLoadingOverlay();
            await applyCoupon(couponCode);
            await onSuccess();
        } catch (error) {
            onError(error);
        }
    });
    /**
     * Handle coupon remove button
     */
    $slideout.find('.ob-removeCoupon').on('click', async (e) => {
        e.preventDefault();

        try {
            const href = $(e.currentTarget).attr('href');
            const urlParams = new URLSearchParams(href.split('?')[1]);
            const couponId = urlParams.get('couponid');

            slideoutController.showLoadingOverlay();
            await removeCoupon(couponId);
            await onSuccess();
        } catch (error) {
            onError(error);
        }
    });

    /**
     * Handle gift certificate form submission
     */
    $slideout.find('.ob-giftCertificate-form').on('submit', async (e) => {
        e.preventDefault();

        const $form = $(e.currentTarget);
        const $input = $form.find('#certcode');
        const giftCertificateCode = $input.val();


        try {
            slideoutController.showLoadingOverlay();
            await applyGiftCertificate(giftCertificateCode);
            await onSuccess();
        } catch (error) {
            onError(error);
        }
    });

    /**
     * Handle gift certificate remove button
     */
    $slideout.find('.ob-removeGiftCertificate').on('click', async (e) => {
        e.preventDefault();

        try {
            const href = $(e.currentTarget).attr('href');
            const urlParams = new URLSearchParams(href.split('?')[1]);
            const giftCertificateId = urlParams.get('giftcertificateid');

            slideoutController.showLoadingOverlay();
            await removeGiftCertificate(giftCertificateId);
            await onSuccess();
        } catch (error) {
            onError(error);
        }
    });
}

/**
 * Bind events for the cart slideout
 * @param {jQuery} $slideout
 * @param {wdSlideout} slideoutController
 */
const bindEvents = ($slideout, slideoutController, initShippingEstimator) => {
    bindCartAccordions($slideout);
    bindCartItemActions($slideout, slideoutController);
    bindForms($slideout, slideoutController);

    if (initShippingEstimator) {
        initShippingEstimator();
    } else {
        shippingEstimatorManager.reInstance();
    }

    $('body').on('shippingEstimator:fetching', () => slideoutController.showLoadingOverlay());
    $('body').on('shippingEstimator:idle', () => slideoutController.hideLoadingOverlay());
};

const shippingEstimatorManager = (() => {
    let instance;
    let creator;

    function setCreator(shippingEstimatorSelector, shippingErrorMessages, callback) {
        creator = () => new ShippingEstimator(shippingEstimatorSelector, shippingErrorMessages, callback);
    }

    function createInstance(shippingEstimatorSelector, shippingErrorMessages, callback) {
        if (!creator) {
            setCreator(shippingEstimatorSelector, shippingErrorMessages, callback);
        }

        return creator();
    }

    function getInstance($shippingEstimator, shippingErrorMessages) {
        if (!creator) {
            setCreator($shippingEstimator, shippingErrorMessages);
        }

        if (!instance) {
            instance = creator($shippingEstimator, shippingErrorMessages);
        }

        return instance;
    }

    function reInstance() {
        instance = null;
        instance = creator();
    }

    function hasInstance() {
        return !!instance;
    }

    return {
        createInstance,
        getInstance,
        reInstance,
        hasInstance,
    };
})();

export default function wdCartSlideout(context) {
    if (!context) {
        console.error('wdCartSlideout: context is not defined');
        return;
    }

    const shippingErrorMessages = {
        country: context.shippingCountryErrorMessage,
        province: context.shippingProvinceErrorMessage,
    };

    $('body').on('cart-quantity-update', async (event, quantity) => {
        try {
            const $pillCountIcon = $('.ob-navCart-countPill');

            let cartQuantity = quantity;

            if (!quantity) {
                const cart = await getCart();
                cartQuantity = Object.values(cart?.lineItems).flat().reduce((acc, item) => acc + item.quantity, 0);
            }

            if (quantity === 0) {
                $pillCountIcon.addClass('ob-navCart-countPill--hidden');
            } else {
                $pillCountIcon.removeClass('ob-navCart-countPill--hidden');
                $pillCountIcon.text(cartQuantity);
            }
        } catch (error) {
            console.error(error);
        }
    });

    const slideoutSelector = '#ob-cart-slideout';
    const slideoutToggleSelector = 'ob-nav-action--cart, [href="/cart.php"]';

    // if on the cart page, just navigate to the cart page
    if (window.location.pathname.includes('/cart.php')) {
        return;
    }

    const slideoutController = wdSlideout({
        slideoutSelector,
        slideoutToggleSelector,
        onSlideoutOpen: initCartSlideout,
        eventNamespace: 'wdCartSlideout',
        debug: false,
    });

    const {
        setSlideoutContent,
        clearSlideoutContent,
        showLoadingOverlay,
        hideLoadingOverlay,
        $slideout,
    } = slideoutController;

    const onSuccess = getSuccessHandler($slideout, slideoutController);

    async function initCartSlideout() {
        // click away from slideout to close
        $(document).on('click', (clickEvent) => {
            const $clickTarget = $(clickEvent.target);
            if ($clickTarget.closest('.modal').length > 0) {
                return;
            }

            if ($(clickEvent.target).closest('a')?.attr('href')?.startsWith('/cart.php')) {
                return;
            }

            if ($(clickEvent.target).closest(slideoutSelector).length === 0) {
                slideoutController.closeSlideout();
            }
        });

        try {
            showLoadingOverlay();
            clearSlideoutContent();

            const cartContent = await getCartContent({ template: 'ob-custom/cart/ob-cart-content' });

            setSlideoutContent(cartContent);

            const initShippingEstimator = () => shippingEstimatorManager.createInstance(
                $('.ob-cart [data-shipping-estimator]'),
                shippingErrorMessages,
                onSuccess,
            );

            if (shippingEstimatorManager.hasInstance()) {
                bindEvents($slideout, slideoutController);
            } else {
                bindEvents($slideout, slideoutController, initShippingEstimator);
            }

            hideLoadingOverlay();
        } catch (error) {
            console.error(error);
            hideLoadingOverlay();
        }
    }
}
